// extracted by mini-css-extract-plugin
module.exports = {"customTab":"FacetsAndOrderByFiltersContent_customTab__VXBKw"};